module.exports = __webpack_public_path__ + "img/mobile_recommendedGame.bb02e644.png";